<template>
<drawer :opened.sync="opened" @close="onCloseBtnClick">
  <template #header>{{operatorTip}}{{auditRuleCategory.name}}</template>

  <template #body>
    <el-form ref="form" :model="model" @keydown.native.enter.prevent="onSaveBtnClick">
      <el-form-item label="是否启用" prop="status">
        <el-switch v-model="model.status" />
      </el-form-item>

      <el-form-item
        v-if="auditRuleCategory.field"
        prop="threshold"
        :label="auditRuleCategory.formTitle"
        :rules="{
          required: true,
          message: `${auditRuleCategory.formTitle}`,
          trigger: 'blur'
        }"
      >
        <el-checkbox-group
          v-if="auditRuleCategory.multi"
          v-model="optValues"
          @change="onOptValuesChange"
        >
          <el-checkbox-button
            v-for="opt in opts"
            :key="opt.value"
            :label="opt.value"
          >{{opt.label}}</el-checkbox-button>
        </el-checkbox-group>
        <el-radio-group
          v-else
          v-model="model.threshold"
          @change="changeDescription"
        >
          <el-radio-button
            v-for="opt in opts"
            :key="opt.value"
            :label="opt.value"
          >{{opt.label}}</el-radio-button>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="规则内容" v-if="model.description" prop="param">
        <p style="width: 900px; margin: 0;">
          <br />
          <span v-for="(item, index) in model.description" :key="index">
            &nbsp;<span v-html="item"></span><span v-show="false">{{model.param}}</span>
            <el-input v-if="(model.description.length -1) !== index" size="small" style="width: 100px;" v-model="model.inputParam[index]" @input="changeParam"/>
          </span>
        </p>
      </el-form-item>

      <el-form-item
        v-if="model.auditRuleTypeId !== 'IonOrdeImpl'"
        label="因子选择"
        prop="factorIds"
        :rules="{
          type: 'array',
          required: true,
          message: '请至少选择一个因子',
          trigger: 'blur'
        }"
      >
        <section class="tree-container border" style="height:400px;">
          <el-tree
            ref="groupFactorTree"
            :key="treeKey"
            :data="groupFactorTree"
            :props="{label: 'name'}"
            :show-checkbox="true"
            :expand-on-click-node="model.auditRuleTypeId === 'RoundingImpl' || model.auditRuleTypeId === 'StableMaterialAnomalyImpl' ? false : true"
            :default-expanded-keys="model.factorIds"
            :auto-expand-parent="false"
            node-key="id"
            @check="onFactorCheckChange"
          >
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <span>{{ node.label }}</span>
            <span v-if="(model.auditRuleTypeId === 'RoundingImpl' || model.auditRuleTypeId === 'StableMaterialAnomalyImpl') && node.label !== '全部因子'">
              {{auditRuleCategory.name === '浓度水平稳定物质数据异常' ? '背景浓度(PPTV):' : '保留位数:'}}
              <el-input
                type="text"
                size="mini"
                v-model="node.data.value"
                placeholder="填写"
                @input="setTreeInput(node,data)"
              />
            </span>
          </span>
          </el-tree>
        </section>
      </el-form-item>
    </el-form>
  </template>

  <template #footer>
    <el-button type="orange" class="btn save-btn" @click="onSaveBtnClick">保存</el-button>
    <a class="cancel-btn btn" @click="onCloseBtnClick">关闭</a>
  </template>
</drawer>
</template>

<script>
import BaseEditor from '../../../BaseEditor'

export default {
  name: 'Editor',
  extends: BaseEditor,
  props: {
    auditRuleCategory: {
      required: true,
      type: Object
    },
    bitMap: {
      type: Object
    },
    auditRuleFactorMap: {
      required: true,
      type: Object
    }
  },
  data () {
    return {
      treeKey: 0,
      optValues: [],
      autoExpandParent: true
    }
  },
  computed: {
    groupFactorTree: {
      get () {
        let factorGroups = JSON.parse(JSON.stringify(this.factorGroups))
        let factorGroupMap = factorGroups.reduce((map, factorGroup) => {
          map[factorGroup.id] = factorGroup
          return map
        }, {})
        let id = this.model.id
        let auditRuleFactorMap = Object.entries(this.auditRuleFactorMap).filter(([auditRuleId]) => auditRuleId !== id).reduce((map, [auditRuleId, auditRuleFactors]) => auditRuleFactors.reduce((map, factorId) => {
          map[factorId] = true
          return map
        }, map), {})

        let factors = JSON.parse(JSON.stringify(this.factors.filter(factor => !auditRuleFactorMap[factor.id])))
        let tmpList = [].concat(factors)
        let roots = []

        for (let i = 0; i < tmpList.length; i++) {
          let item = tmpList[i]
          item.value = 0
          let {parentId} = item
          let parent = factorGroupMap[parentId]

          if (parent) {
            let {children} = parent

            if (!Array.isArray(children)) {
              children = parent.children = []
              tmpList.push(parent)
            }

            children.push(item)
          } else {
            roots.push(item)
          }
        }

        return [{
          id: -1,
          name: '全部因子',
          children: roots
        }]
      },
      set () {}
    },
    opts () {
      let {auditRuleCategory} = this
      let list = []

      if (auditRuleCategory.field) {
        let start
        let end

        if (auditRuleCategory.multi) {
          start = 0
          end = 24
        } else {
          start = 1
          end = 25
        }

        for (let i = start; i < end; i++) {
          list.push({
            value: 1 << i,
            label: i.toString().padStart(2, '0')
          })
        }
      }

      return list
    }
  },
  methods: {
    save (callback, idKey) {
      let refForm = this.getForm()

      refForm && refForm.validate(flag => {
        if (!flag) {
          return
        }

        this.beforeSave()

        this.changeLoadStatus(true)
        let model = JSON.parse(JSON.stringify(this.model))
        if (model.auditRuleTypeId === 'IonOrdeImpl') {
          model.factorIds = ['6103', '6104', '6108', '6101', '6111', '6109', '6110', '6107', '6100']
        }

        this.$api[this.apiKey].save(model, this.operator).then(data => {
          if (data) {
            this.$notify({
              title: '成功',
              message: '保存成功',
              type: 'success',
              position: 'bottom-right'
            })
            this.onSave(data)
            callback && callback(data)
          }
        }).catch(console.error).finally(() => {
          this.changeLoadStatus(false)
        })
      })
    },
    setTreeData () {
      let {groupFactorTree, model: {factors, auditRuleTypeId}} = this
      let keyMap = {
        'RoundingImpl': 'digit',
        'StableMaterialAnomalyImpl': 'background'
      }
      this.groupFactorTree = JSON.parse(JSON.stringify(this.recursionData(groupFactorTree, factors, keyMap[auditRuleTypeId])))
    },
    recursionData (data, factors, key) {
      data.forEach(el => {
        if (el.children) {
          this.recursionData(el.children, factors, key)
          return
        }

        factors.forEach(item => {
          if (item.factorId === el.id) {
            el.value = item[key]
          }
        })
      })

      return data
    },
    beforeSave () {
      // delete this.model.inputParam
    },
    changeParam () {
      this.model.param = this.model.inputParam.join('|')
    },
    setTreeInput (node, data) {
      if (data.children) {
        data.children.forEach(el => {
          this.setTreeInput(node, el)
        })
      }

      data.value = node.data.value
      this.onFactorCheckChange()
    },
    initModel () {
      let tree = this.getGroupFactorTree()
      tree && tree.setCheckedKeys([])

      this.optValues = []

      let {auditRuleCategory} = this
      if (!auditRuleCategory.description) {
        return {
          id: null,
          auditRuleTypeId: (this.auditRuleCategory || {}).id,
          threshold: null,
          status: true,
          factorIds: []
        }
      }
      let description = auditRuleCategory.description
      if (auditRuleCategory.field) {
        description = description.replace(new RegExp(`\\{\\{${auditRuleCategory.field}\\}\\}`, 'ig'), `<span style="color:#409EFF;">--</span>`)
        let reg = /\{\{[^}]+\}\}/
        description = description.split(reg)

        let inputParam = []
        for (let i = 0; i < description.length - 1; i++) {
          inputParam.push(0)
        }

        return {
          id: null,
          auditRuleTypeId: (this.auditRuleCategory || {}).id,
          threshold: null,
          status: true,
          description: description,
          inputParam: inputParam,
          param: inputParam.join('|'),
          factorIds: []
        }
      }

      if (auditRuleCategory.description.search('param') !== -1) {
        let reg = /\{\{[^}]+\}\}/
        description = description.split(reg)

        let inputParam = []
        for (let i = 0; i < description.length - 1; i++) {
          inputParam.push(0)
        }

        return {
          id: null,
          auditRuleTypeId: (this.auditRuleCategory || {}).id,
          status: true,
          description: description,
          inputParam: inputParam,
          param: inputParam.join('|'),
          factorIds: []
        }
      }

      return {
        id: null,
        auditRuleTypeId: (this.auditRuleCategory || {}).id,
        threshold: null,
        status: true,
        factorIds: []
      }
    },
    onOpen () {
      this.treeKey++
    },
    onFactorCheckChange () {
      let checkedNodeList = this.getGroupFactorTree().getCheckedNodes()
      this.model.factorIds = checkedNodeList.filter(item => !Array.isArray(item.children)).map(item => item.id)

      let temp = {
        'RoundingImpl': 'digit',
        'StableMaterialAnomalyImpl': 'background'
      }
      let factors = checkedNodeList.filter(item => !Array.isArray(item.children))
      this.model.factors = factors.map(el => {
        let data = {
          auditRuleId: this.model.id,
          factorId: el.id
        }

        if (this.model.auditRuleTypeId === 'RoundingImpl' || this.model.auditRuleTypeId === 'StableMaterialAnomalyImpl') {
          data[temp[this.model.auditRuleTypeId]] = el.value
        }

        return data
      })
    },
    resetTree (data, node) {
      if (data.children) {
        this.resetTree(data.children, node)
      }

      data.forEach(el => {
        if (el.id === node.id) {
          el.value = node.value
        }
      })
    },
    afterGetDetail (model) {
      this.setTreeData()
      // if ((model.auditRuleTypeId === 'RoundingImpl' || model.auditRuleTypeId === 'StableMaterialAnomalyImpl') && model.factors.length > 0) {
      //   let temp = {
      //     'RoundingImpl': 'digit',
      //     'StableMaterialAnomalyImpl': 'background'
      //   }
      //   model.factors.forEach(el => {
      //     console.log({'id': el.factorId, 'value': el[temp[model.auditRuleTypeId]]})
      //     this.setTreeInput(this.groupFactorTree, {'id': el.factorId, 'value': el[temp[model.auditRuleTypeId]]})
      //   })
      // }

      let refTree = this.getGroupFactorTree()
      refTree && refTree.setCheckedKeys(model.factorIds)

      let {auditRuleCategory} = this

      if (auditRuleCategory.field) {
        if (auditRuleCategory.multi) {
          let {threshold} = model
          let optValues = this.optValues = []

          while (threshold > 0) {
            let bit = -threshold & threshold
            threshold ^= bit
            optValues.push(bit)
          }
        }
      }

      if (!model.param) return
      let description = auditRuleCategory.description
      model.inputParam = model.param.split('|')
      if (auditRuleCategory.field) {
        const { bitMap } = this
        let tmpVal = model.threshold
        let replaceValue = bitMap[tmpVal]
        if (auditRuleCategory.multi) {
          const l = []
          while (tmpVal > 0) {
            const bit = -tmpVal & tmpVal
            tmpVal ^= bit
            l.push(bitMap[bit])
          }
          replaceValue = l.join(',')
        }
        description = description.replace(new RegExp(`\\{\\{${auditRuleCategory.field}\\}\\}`, 'ig'), `<span style="color:#409EFF;">${replaceValue}</span>`)
      }
      let reg = /\{\{[^}]+\}\}/
      model.description = description.split(reg)
    },
    changeDescription (data) {
      this.model.description = this.model.description.map(el => {
        if (el.indexOf('--') !== -1) {
          el = el.replace(new RegExp(`\\-\\-`, 'ig'), Math.log2(data))
        }
        return el
      })
    },
    onOptValuesChange (data) {
      this.model.threshold = this.optValues.reduce((count, value) => count | value, 0)
      this.model.description = this.model.description.map(el => {
        if (el.indexOf('--') !== -1) {
          el = el.replace(new RegExp(`\\-\\-`, 'ig'), Math.log2(data))
        }
        return el
      })
    },
    getGroupFactorTree () {
      return this.$refs.groupFactorTree
    }
  }
}
</script>

<style lang="scss" scoped>
.el-radio-button {
  /deep/ {
    .el-radio-button__inner {
      padding: 10px;
    }
  }
}

.el-checkbox-group {
  display: block;
  float: left;
  width: 100%;

  /deep/ {
    .el-checkbox-button__inner {
      padding: 10px;
    }
  }
}
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}
.el-input--mini /deep/ .el-input__inner {
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/views/09System-Settings/04Config/05Auto-Audit-Rule/Editor.vue